import React, { useState } from 'react';
import { Button, Modal, Box, TextField, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import donationApi from '../../apis/donationApi';
import { useSnackbar } from 'notistack';

const ZeroWasteFeeConfigModal = ({ currentPartnerId, onSuccess }: any) => {
  const [open, setOpen] = useState(false);
  const [basePrice, setBasePrice] = useState(6000);
  const [newBracketName, setNewBracketName] = useState('');
  const [newBracketWeight, setNewBracketWeight] = useState(0);
  const [openConfirmBasePrice, setOpenConfirmBasePrice] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  
  const handleOpenConfirmBasePrice = () => {
    setOpenConfirmBasePrice(true);
  };
  
  const handleCloseConfirmBasePrice = () => {
    setOpenConfirmBasePrice(false);
  };

  const handleUpdateBasePrice = async () => {
    try {
      const res = await donationApi.updateZeroWasteBasePrice({ base_price: basePrice });
      if (res.data.code === 0) {
        enqueueSnackbar('Đã cập nhật giá mới cho tất cả khung trọng lượng!', { variant: 'success' });
        onSuccess();
        setOpen(false);
      } else {
        enqueueSnackbar('Lỗi cập nhật: ' + (res.data.debugMessage || res.data.message), { variant: 'error' });
      }
      handleCloseConfirmBasePrice();
    } catch (error) {
      enqueueSnackbar('Cập nhật thất bại', { variant: 'error' });
      handleCloseConfirmBasePrice();
    }
  };

  const handleAddBracket = async () => {
    try {
      const res = await donationApi.createZeroWasteBasePrice({ name: newBracketName, weight: newBracketWeight, base_price: basePrice, partnerId: currentPartnerId });
      if (res.data.code === 0) {
        enqueueSnackbar('Đã thêm khung trọng lượng mới!', { variant: 'success' });
        onSuccess();
        setOpen(false);
      } else {
        enqueueSnackbar('Lỗi thêm khung: ' + (res.data.debugMessage || res.data.message), { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Thêm thất bại', { variant: 'error' });
    }
  };

  return (
    <>
      <Button variant="contained" color="success" onClick={() => setOpen(true)} style={{ float: 'right', marginBottom: '10px' }}>
        Cấu hình giá xử lí
      </Button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 500, bgcolor: 'background.paper', p: 4, borderRadius: 2 }}>
          <Typography variant="h6" mb={2}>Cấu hình giá cơ bản</Typography>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '20px' }}>
            <TextField label="Giá 1kg (VNĐ)" type="number" value={basePrice} onChange={(e) => setBasePrice(Number(e.target.value))} size="small" />
            <Button variant="contained" onClick={handleOpenConfirmBasePrice}>Áp dụng toàn bộ</Button>
          </div>
          <hr />
          <Typography variant="h6" mt={2} mb={2}>Thêm khung trọng lượng</Typography>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <TextField label="Tên (VD: 31-40kg)" value={newBracketName} onChange={(e) => setNewBracketName(e.target.value)} size="small" />
            <TextField label="Cận trên (VD: 40)" type="number" value={newBracketWeight} onChange={(e) => setNewBracketWeight(Number(e.target.value))} size="small" style={{ width: '120px' }} />
            <Button variant="contained" color="success" onClick={handleAddBracket}>Thêm</Button>
          </div>
        </Box>
      </Modal>

      <Dialog
        open={openConfirmBasePrice}
        onClose={handleCloseConfirmBasePrice}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Xác nhận áp dụng"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bạn có chắc chắn muốn áp dụng giá cơ bản mới cho tất cả khung trọng lượng không?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmBasePrice}>Hủy</Button>
          <Button onClick={handleUpdateBasePrice} autoFocus color="primary">
            Áp dụng
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ZeroWasteFeeConfigModal;


